<template>
  <div>
    <!-- Password gate -->
    <div v-if="!unlocked" class="preview-lock">
      <form class="preview-lock-box" @submit.prevent="checkPassword">
        <h2 class="preview-lock-title">Protected Page</h2>
        <p class="preview-lock-sub">
          Please enter the password to view this page.
        </p>
        <input
          v-model="passwordInput"
          type="password"
          class="preview-lock-input"
          placeholder="Password"
          autofocus
        />
        <button type="submit" class="btn preview-lock-btn">Enter</button>
        <p v-if="error" class="preview-lock-error">
          Incorrect password. Please try again.
        </p>
      </form>
    </div>

    <template v-else>
      <div class="menu-back-wrap">
        <div class="menu-back"></div>
      </div>
      <topnav></topnav>
      <div class="main-carousel-wrap">
        <carousel
          :nav="false"
          :dots="true"
          :items="1"
          :autoplay="true"
          :autoplayTimeout="8000"
          :mouseDrag="false"
          :touchDrag="false"
        >
          <div
            class="main-slide-wrap"
            v-for="slide in slides"
            :key="slide._id"
          >
            <div class="main-slide-wrap-txt">
              <h1 v-html="slide.title.split('\n').join('<br />')" />
              <p
                class="slide-sub"
                v-html="
                  slide.subtitle ? slide.subtitle.split('\n').join('<br />') : ''
                "
              ></p>
              <p v-if="!slide.link && slide.callToAction" class="red-block">
                {{ slide.callToAction }}
              </p>
              <div class="main-slide-btn-wrap" v-if="slide.link">
                <a :href="slide.link" class="btn">{{ slide.callToAction }} </a>
              </div>
              <p v-if="slide.legalText" class="small-main-txt">
                {{ slide.legalText }}
              </p>
            </div>
            <div
              class="main-slide-img"
              :class="{ 'under-title': slide.underTitle }"
              :style="slide.image.altText"
            >
              <img
                :src="slide.image.imageURL"
                :style="{ maxWidth: slide.maxWidth + 'px' }"
              />
            </div>
          </div>
        </carousel>
      </div>
      <div class="scroll-apps">
        <div class="scroll-apps-wrap">
          <div class="scroll-apps-track">
            <img
              v-for="item in $local.topGraph.lineOne"
              :key="'lineOne-a-' + item.imageName"
              :src="item.imageURL + '&resize=400'"
              class="app-scroll"
            />
          </div>
          <div class="scroll-apps-track" aria-hidden="true">
            <img
              v-for="item in $local.topGraph.lineOne"
              :key="'lineOne-b-' + item.imageName"
              :src="item.imageURL + '&resize=400'"
              class="app-scroll"
            />
          </div>
        </div>
        <div class="scroll-apps-wrap rev">
          <div class="scroll-apps-track">
            <img
              v-for="item in $local.topGraph.lineTwo"
              :key="'lineTwo-a-' + item.imageName"
              :src="item.imageURL + '&resize=400'"
              class="app-scroll"
            />
          </div>
          <div class="scroll-apps-track" aria-hidden="true">
            <img
              v-for="item in $local.topGraph.lineTwo"
              :key="'lineTwo-b-' + item.imageName"
              :src="item.imageURL + '&resize=400'"
              class="app-scroll"
            />
          </div>
        </div>
      </div>
      <div class="who-sec">
        <div class="side-txt-box who">
          <div class="side-who-top-wrap">
            <div class="side-head-wrap">
              <h3 class="txt60">Who are We?&nbsp;</h3>
            </div>
            <div class="side-txt-wrap">
              <p>
                Play.Works develops and publishes games across a network of over
                400m televisions via its proprietary technology platform.
                Play.Works can be found on Sky, LG, Samsung, ROKU, Fire TV,
                Comcast, Cox, Videotron, Rogers, British Telecom, Vizio, and
                most major pay TV platforms in North America and the UK
              </p>
              <p>
                Delivering rich casual games and entertainment to the primary
                screen in the home, the company continues to grow exponentially
                and has become a must have addition for major pay TV, CTV and
                OTT operators. Play.Works’ extensive library of games and video
                content positions it firmly as the primary player in the
                explosive CTV market.
              </p>
            </div>
          </div>
          <Stats></Stats>
        </div>
      </div>
      <div class="partners-sec">
        <div class="w700">
          <h3 class="txt90 red">Partners</h3>
          <p class="txt18">
            Play.Works has long-standing relationships with the biggest and most
            innovative TV platforms in the world.
          </p>
        </div>
        <img
          v-for="bigPartner in bigPartners"
          :key="bigPartner._id"
          :src="bigPartner.logo.imageURL"
          :alt="bigPartner.name"
          class="partner-logo big"
        />
        <div class="small-logos-wrap">
          <img
            v-for="partner in partners"
            :key="partner._id"
            :src="partner.logo.imageURL"
            :alt="partner.name"
            class="partner-logo"
          />
        </div>
      </div>
      <div class="big-vid-wrap homepage">
        <div class="big-vid">
          <iframe
            src="https://cdn.jwplayer.com/players/sWEcVjTL-4DULHiTS.html"
            allowfullscreen
            frameborder="0"
            style="
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
            "
          ></iframe>
        </div>
      </div>
      <div class="games-sec">
        <h3 class="txt90">Games</h3>
        <div class="w700">
          <p class="txt18">
            Play.Works was one of the first to understand how best to engage
            viewers through games & video apps on Connected TVs. Our proprietary
            technology allows for real time monetization and content
            synchronization across our distribution channels.
          </p>
        </div>
        <div class="games-home-wrap">
          <div
            v-for="game in featuredGames"
            :key="game._id"
            class="game-home-box"
          >
            <img :src="game.icon.imageURL" class="game-img-box" />
            <h4 class="txt30">{{ game.name }}<br /></h4>
            <p v-html="game.aboutGame" class="game-box-txt"></p>
          </div>
        </div>
        <router-link to="/games" class="btn bigger blue games-btn"
          >All Games</router-link
        >
      </div>
      <div class="influencers-sec">
        <div class="side-head-wrap influ">
          <h3 class="txt60">TV's New Voices</h3>
        </div>
        <div class="influ-imgs-wrap desktop">
          <img
            :src="$local.topGraph.tVsNewVoices.imageURL"
            :alt="$local.topGraph.tVsNewVoices.altText"
          />
        </div>
        <div class="influ-imgs-wrap mobile">
          <img
            :src="$local.topGraph.tVsNewVoicesMobile.imageURL"
            :alt="$local.topGraph.tVsNewVoicesMobile.altText"
          />
        </div>
        <div class="influ-txt-box">
          <div class="txt18" v-html="$local.topGraph.tVsNewVoicesText"></div>
          <a href="/tv-channels#stars" class="btn bigger influ-btn">More</a>
          <img src="../assets/pattern1 blue copy 144.svg" class="influ-icon" />
        </div>
      </div>
      <botfooter></botfooter>
    </template>
  </div>
</template>

<script>
import Botfooter from "@/components/Botfooter.vue";
import Topnav from "@/components/Topnav.vue";
import Stats from "../components/Stats.vue";
import carousel from "sh-v-owl-carousel";

export default {
  components: {
    carousel,
    Topnav,
    Botfooter,
    Stats,
  },
  data: () => ({
    bigPartners: [],
    partners: [],
    faq: [],
    games: [],
    topGraph: {},
    unlocked: false,
    passwordInput: "",
    error: false,
    previewPassword: "playworks2026",
  }),
  computed: {
    slides() {
      const staging = process.env.VUE_APP_IS_STAGING;
      let slides = this.$local.topGraph.carousel || [];
      if (staging) slides = slides.filter((c) => c.staging || c.live);
      else slides = slides.filter((c) => c.live);
      return slides;
    },
    featuredGames() {
      const games = (this.$local.topGraph.featuredGame || []).slice();
      return games.sort((a, b) => (a.order || 0) - (b.order || 0));
    },
  },
  methods: {
    checkPassword() {
      if (this.passwordInput === this.previewPassword) {
        this.unlocked = true;
        this.error = false;
        try {
          localStorage.setItem("oldHomeUnlocked", "true");
        } catch (e) {
          // ignore storage errors
        }
      } else {
        this.error = true;
      }
    },
  },
  created() {
    try {
      if (localStorage.getItem("oldHomeUnlocked") === "true") {
        this.unlocked = true;
      }
    } catch (e) {
      // ignore storage errors
    }
    const meta = document.createElement("meta");
    meta.name = "robots";
    meta.content = "noindex, nofollow";
    meta.setAttribute("data-old-home-noindex", "true");
    document.head.appendChild(meta);
  },
  beforeDestroy() {
    const meta = document.head.querySelector(
      'meta[data-old-home-noindex="true"]',
    );
    if (meta) document.head.removeChild(meta);
  },
  async beforeMount() {
    let { data: faq } = await this.$db
      .collection("faq")
      .sort("order", "asc")
      .get();
    this.faq = faq;
    let { data: bigPartners } = await this.$db
      .collection("partners")
      .sort("order", "asc")
      .query("bigLogo", "=", true)
      .get();
    this.bigPartners = bigPartners;
    let { data: partners } = await this.$db
      .collection("partners")
      .sort("order", "asc")
      .query("bigLogo", "!=", true)
      .query("draft", "=", false)
      .get();
    this.partners = partners;
    let { data: g } = await this.$db
      .collection("games")
      .sort("_rank", "asc")
      .query("draft", "=", false)
      .everything()
      .perPage(6)
      .get();
    this.games = g;
  },
  name: "OldHome",
};
</script>
